import type { CapiPlp } from 'types/capi/plp';
import { fromProductListItem } from 'types/TrackableProduct';
import type { User } from 'types/User';

import gtm from '~/services/gtm.client';
import tiktok from '~/services/tiktok.pixel';
import twitter from '~/services/twitter.pixel';

import UserEvent from './UserEvent';

type EventData = {
  clientIp: string | null;
  isBot: boolean;
  plp: CapiPlp;
  user: User;
};

class PlpViewEvent extends UserEvent<EventData> {
  private getProductIds() {
    return this.data.plp.products.map((product) => product.id);
  }

  sendToTikTok() {
    return tiktok.fireEvent('ViewContent', {
      content_ids: this.getProductIds(),
      content_type: 'product'
    });
  }

  sendToTwitter() {
    return twitter.fireEvent(twitter.EventIds.ViewContent, {
      contents: this.getProductIds().map((productId) => ({
        content_id: productId,
        content_type: 'product'
      }))
    });
  }

  sendToGtm() {
    return gtm.Ecommerce.viewListItems(
      this.data.plp.products,
      this.data.plp.path_root
    );
  }

  collectServerEvents() {
    const { plp, clientIp } = this.data;
    const url = window.location.href;
    const urlObj = new URL(url);

    const plpViewEvent = {
      data: {
        client_ip: clientIp,
        currency: plp.products[0]?.price.currency,
        has_search_term: urlObj.searchParams.has('q'),
        is_filtered: plp.filter_options.some((o) => o.active),
        is_logged_in: this.data.user.isLoggedIn,
        is_sorted: urlObj.searchParams.has('sort'),
        item_list_name: new URL(plp.canonical_url).pathname,
        items: plp.products.map((p, i) =>
          gtm.Ecommerce.getEcommerceItem(fromProductListItem(p), i + 1)
        ),
        product_type: plp.type,
        url,
        useragent: navigator.userAgent
      },
      type: 'plp_view' as const
    };

    this.serverEvents.push(plpViewEvent);
  }
}

export default PlpViewEvent;
